import React, {memo, useEffect, useState} from 'react';
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import Utils from "@/utils/Default/Utils";
import {FILTER_AVAILABILITY_SHOP_ID_LIST_CODE} from "@/utils/constants";
import productListAnimation from "@/animations/Default/productListPage";
export const FilterModal = memo((props) => {
    const {euroPricesRange} = props;
    let filterSelectedIndex = ((props.newProductsListData?.filters?.values?.length) == 2) ? 1 : props.newProductsListData.filters.values.findIndex(filterItem => filterItem[1] === props.filterSelected)
    const selectedFilterCode = filterSelectedIndex !== -1 ? props.newProductsListData.filters.values[filterSelectedIndex][1]: null
    useEffect(() => {
        props.setAccordion(selectedFilterCode)
    }, [props.filterSelected]);

    const getPricesRange = (filterValues, code) => {
        const searchPriceValue = filterValues.findIndex((searchPriceValue) => searchPriceValue[2] == code)
        let obj = filterValues[searchPriceValue]
        if (obj != undefined) {
            if (code == "MinApplicableValue" || code == "MinAppliedValue") {
                return Math.floor(filterValues[searchPriceValue][3])
            } else if (code == "MaxApplicableValue" || code == "MaxAppliedValue") {
                return Math.ceil(filterValues[searchPriceValue][3])
            }
        }
    }

    const stopPropagation = (event) => {
        event.stopPropagation();
    }

    const getMetaInfosValueByCode = (code, metaInfosList) => {
        if (metaInfosList) {
            var key = metaInfosList.codes.indexOf(code);
            if (key != -1) {
                return metaInfosList.items[key].value;
            }
        }
        return '';
    }

    const toogleAccordion = (index) => {
        props.setFilterBrands("")
        if (props.inputSearch.value) {
            props.inputSearch.current.value = '';
        }
        if (index == props.accordion) {
            props.setAccordion(null)
        } else {
            props.setAccordion(index)
        }
    };

    const allowedVisibleBrands = 8
    const [visibleBrands, setvisibleBrands] = useState(allowedVisibleBrands)
    let renderAllFiltersTypes = (itemFilter, indexItem) => {
        let counterFilterApplied = 0
        const itemFilterToRenderTotal = itemFilter[5].filter(filtre => (filtre[1] && (filtre[1]).toLowerCase().includes(props.filterBrands)))
        let itemFilterToRender = itemFilterToRenderTotal
        if (itemFilter[1] == "Marque"){
            itemFilterToRender = itemFilterToRenderTotal.slice(0, visibleBrands)
        }
        const handleShowMore = () => {
            setvisibleBrands(visibleBrands + allowedVisibleBrands);
        }
        return (
            <li className={`accordion__item${itemFilter[1] == props.accordion ? ' _open' : ' _close'}`} key={indexItem}>
                <div className="accordion__item__header">
                    <button onClick={(event) => {
                        toogleAccordion(itemFilter[1])
                    }}>
                        <span>{itemFilter[0]} {itemFilter[3] != null ? `(${itemFilter[3]})` : ""} </span>
                        <span className='filters-actives'>
                            {(itemFilter[0] == "Trier") && props.sortSelected}
                            {props.newProductsListData.appliedFiltersValues.map((itemFilterValue) => {
                                if (itemFilterValue.filterCode == itemFilter[1]) {
                                    counterFilterApplied++
                                    return (
                                        `${counterFilterApplied > 1 ? ", " : ""}${itemFilterValue.label}${itemFilterValue.unit != null ? " " + itemFilterValue.unit : ''}`
                                    )
                                }
                            })}
                        </span>
                    </button>
                </div>
                <div className="accordion__item__form">
                    <fieldset className={`accordion__item__form--${itemFilter[1] == "LB_COLOR_COMPARIO" ? "type-color-checkbox" : itemFilter[1] == "Trier" ? "type-simple-radio" : itemFilter[2] == "Slider" ? "type-range" : "type-simple-checkbox"}`}>
                        <legend>{itemFilter[0]}</legend>
                        {itemFilter[1] == "Marque" &&
                            <div>
                                <input
                                    type="search"
                                    ref={props.inputSearch}
                                    name="searchBrand"
                                    autoComplete='off'
                                    placeholder='Recherche'
                                    onChange={(e) => { props.setFilterBrands((e.target.value).toLowerCase()) }}
                                />
                            </div>
                        }
                        {itemFilter[2] == "Slider" ?
                            <div className={"field"}>
                              <div className="range-values accordion__item__form--type-range-values">
                                <span className='min-price'>{getPricesRange(itemFilter[5],getPricesRange(itemFilter[5], "MinAppliedValue") == null ? "MinApplicableValue" : "MinAppliedValue") + ' €'}</span>
                                <span className='max-price'>{getPricesRange(itemFilter[5],getPricesRange(itemFilter[5], "MaxAppliedValue") == null ? "MaxApplicableValue" : "MaxAppliedValue") + ' €'}</span>
                              </div>
                              <Nouislider
                                step={1}
                                range={{
                                    min: getPricesRange(itemFilter[5], "MinApplicableValue"),
                                    max: getPricesRange(itemFilter[5], "MaxApplicableValue")
                                }}
                                start={[
                                    getPricesRange(itemFilter[5], "MinAppliedValue") == null ? getPricesRange(itemFilter[5], "MinApplicableValue") : getPricesRange(itemFilter[5], "MinAppliedValue"),
                                    getPricesRange(itemFilter[5], "MaxAppliedValue") == null ? getPricesRange(itemFilter[5], "MaxApplicableValue") : getPricesRange(itemFilter[5], "MaxAppliedValue")]}
                                connect
                                onSlide={(event) => {productListAnimation.updateFilterPrices(event, euroPricesRange)}}
                                onChange={(event) => props.updateChangeNouiSlider(event, itemFilter[0])}/>
                            </div>
                            :
                            itemFilterToRender.map((itemFilterValue, indexFilter) => {
                                return (
                                    <label>
                                        <a className={'hidden_seoUrl_link'} href={Utils.getMetaInfosValueByCode("seoUrl", itemFilterValue[6])}>
                                            {itemFilter[1] == "Trier" ?
                                                <input
                                                    onChange={(event) => props.changeSortCriteria(event, itemFilterValue)}
                                                    type="radio"
                                                    name="sort"
                                                    checked={props.sortSelected == itemFilterValue[1] ? true : false}
                                                    value={itemFilterValue[1] != "" ? itemFilterValue[1] : props.firstRadioSort}
                                                    id={itemFilterValue[3] != "" ? itemFilterValue[3] : "topVente"}
                                                />
                                                :
                                                <input
                                                    onChange={(event) => props.updateFilter(event, itemFilter, itemFilterValue)}
                                                    type="checkbox"
                                                    name={itemFilterValue[3]}
                                                    checked={itemFilterValue[5] == true ? true : false}
                                                    id={itemFilterValue[3]}
                                                    className={itemFilter[1] == "LB_COLOR_COMPARIO" ? `checkbox-color--${getMetaInfosValueByCode("Style", itemFilterValue[6])}` : null}
                                                />
                                            }
                                            {itemFilterValue[5] == false ?
                                                <div
                                                    tabIndex="-1"
                                                    className={`accordion__item__form--type-simple-checkbox__${itemFilter[1] == "Moyenne" && `stars stars--${itemFilterValue[1]}`} accordion__item__form--type-simple-checkbox__${itemFilter[1] == "Moyenne" && `stars stars--${itemFilterValue[1]}`}`}
                                                >
                                                    <span>{props.newProductsListData.lastLevelLabel}</span>
                                                    {itemFilterValue[1]} {itemFilterValue[4] != null ? itemFilterValue[4] : ""}
                                                    {itemFilter[1] == "LB_COLOR_COMPARIO" && <br />}
                                                    {itemFilterValue[7] && ` (${itemFilterValue[7]})`}</div>
                                                :
                                                <div
                                                    className={`accordion__item__form--type-simple-checkbox__${itemFilter[1] == "Moyenne" && `stars stars--${itemFilterValue[1]}`} accordion__item__form--type-simple-checkbox__${itemFilter[1] == "Moyenne" && `stars stars--${itemFilterValue[1]}`}`}>
                                                    <span>{props.newProductsListData.lastLevelLabel}</span>
                                                    {itemFilterValue[1]} {itemFilterValue[4] != null ? itemFilterValue[4] : ""}
                                                    {itemFilter[1] == "LB_COLOR_COMPARIO" && <br />}
                                                    {itemFilterValue[7] && ` (${itemFilterValue[7]})`}
                                                </div>
                                            }
                                        </a>
                                    </label>
                                )
                            })}
                            {
                            (itemFilter[1] == "Marque") && itemFilterToRenderTotal.length > visibleBrands &&
                                <button onClick={handleShowMore}>Voir plus</button>
                            }
                    </fieldset>
                </div>
            </li>
        )
    }

    return (
        <div id="filters" role="dialog" className={`dp__filter-modal dp__filter-modal${"--" + props.showModal}`} onClick={(event) => props.filterModal(null)}>
            <aside className={`dp__filter-modal__dialog dp__filter-modal__dialog${"--" + props.showModal}`} onClick={(event) => stopPropagation(event)}>
                <div className="dp__filter-modal__dialog__content">
                    <div className="dp__filter-modal__dialog__content__header">
                        <div className="dp__filter-modal__dialog__content__header__title">Filtrer et trier les résultats</div>
                        <button type="button"
                            className="dp__filter-modal__dialog__content__header__close"
                            onClick={(event) => props.filterModal(null)}
                            aria-label="fermer">
                        </button>
                    </div>
                    <div className="dp__filter-modal__dialog__content__body" ref={props.filterScrollEl}>
                        {props.newProductsListData.filters.values != undefined && props.newProductsListData.filters.values.length > 0 &&
                            <ul className="accordion">
                                {
                                    props.newProductsListData.filters.values.map((itemFilter, index) => {
                                        if(itemFilter[1] == FILTER_AVAILABILITY_SHOP_ID_LIST_CODE){
                                            return null
                                        }
                                        else if (props.filterSelected != null && props.filterSelected == itemFilter[1]) {
                                            return (
                                                renderAllFiltersTypes(itemFilter, index)
                                            )
                                        }
                                    })}
                                {
                                    props.newProductsListData.filters.values.map((itemFilter, index) => {
                                        if(itemFilter[1] == FILTER_AVAILABILITY_SHOP_ID_LIST_CODE){
                                            return null
                                        }
                                        else if (props.filterSelected != itemFilter[1]) {
                                            return (
                                                renderAllFiltersTypes(itemFilter, index)
                                            )
                                        }
                                    })}
                            </ul>
                        }
                    </div>
                    <div className="dp__filter-modal__dialog__content__footer">
                        {props.newProductsListData.appliedFiltersValues.length > 0 || props.sortSelected != props.firstRadioSort ?
                            <button
                                onClick={(event) => props.removeAllFiltersActive()}
                                type="button"
                                className="dp__filter-modal__dialog__content__footer__btn-remove">
                                Tout effacer
                            </button>
                            : null}
                        <button type="button"
                            className="dp__filter-modal__dialog__content__footer__btn-result"
                            onClick={(event) => props.filterModal(null)}>
                            {props.newProductsListData.itemsCount > 1 ? 'Résultats' : 'Résultat'} ({props.newProductsListData.itemsCount})
                        </button>
                    </div>
                </div>
            </aside>
        </div>
    )
})